import { make, dispatch } from 'vuex-pathify'
import BookingFlowService from '../../services/booking-flow/service';
import * as _ from "lodash";
import Cookies from 'js-cookie';

const getDefaultState = () => {
  return {
    id: null,
    title: "MR",
    first_name: "",
    last_name: "",
    email: "",
    mobile: "",
    fax: "",
    credits: 0,
    company_name: "",
    town: "",
    postcode: "",
    county: "",
    address: "",
    password: "",
    opt_in: true,
    existingUser: false,
    hasAccount: false,
    vehicles: null,
    passwordChanged: false,
    cVehicleMake: null,
    cVehicleModel: null,
    cVehicleColour: null,
    cVehicleReg: null,
    passengers: [],
    maximail: null
  }
}

// initial state
const state = getDefaultState();


const mutations = make.mutations(state);

const actions = {
  ...make.actions(state),
  
  // customer login
  async customerLogin(context, credentials) {
    await BookingFlowService.login(credentials).then((res) => {
      if(res['data'].type !== 'error') {
        if(res['data'].customer) {
          dispatch('auth/setLoggedIn' , true)
          dispatch('auth/setToken' , res['data'].token)

          context.dispatch("setCredits", res['data'].customer.credits)
          context.dispatch("setId", res['data'].customer.customerId)
          context.dispatch("setTitle", res['data'].customer.title)
          context.dispatch("setFirst_name", res['data'].customer.firstName)
          context.dispatch("setLast_name", res['data'].customer.lastName)
          context.dispatch("setMobile", res['data'].customer.mobile)
          context.dispatch("setOpt_in", res['data'].customer.optIn)
          context.dispatch("setVehicles", res['data'].customer.cars)
          context.dispatch("setCVehicleMake", res['data'].customer.cVehicleMake)
          context.dispatch("setCVehicleModel", res['data'].customer.cVehicleModel)
          context.dispatch("setCVehicleColour", res['data'].customer.cVehicleColour)
          context.dispatch("setCVehicleReg", res['data'].customer.cVehicleReg)

        } else {
          dispatch('auth/setLoggedIn' , false)
        }
      }
    }).catch(() => dispatch('auth/setLoggedIn' , false));
  },

  logout() {
    this.state.customer = getDefaultState();
    Cookies.remove(`${window.location.host || 'skyparksecure'}`, { path: '/' })
  },

  // get customer credits
  async getCredits(context) {
    await BookingFlowService.getCustomer(this.state.auth.token, this.state.customer.id)
    .then(res => context.dispatch("setCredits", res['data'].credits))
    .catch(() =>  context.dispatch('setCredits', 0));
  },

  // generate new password for customer
  async forgottenPassword(context, email) {
    await BookingFlowService.password(email)
    .then(() => context.dispatch('setPasswordChanged', true))
    .catch(() =>  context.dispatch('setPasswordChanged', false));
  },

  // email lookup - this is ran on debounced keyup
  async emailLookup(context, email) {
    await BookingFlowService.emailLookup(email)
    .then((res) => context.dispatch('setExistingUser', res['data'].type === "success"))
    .catch(() =>  context.dispatch('setExistingUser', false));
  },

  // email lookup - this is ran on debounced keyup
  async createAccount(context, password) {
    await BookingFlowService.createAccount({ 
      token: null, 
      customer: {
        ...context.state,
        firstName: context.state.first_name,
        lastName: context.state.last_name,
        postCode: context.state.postcode,
        password 
      }
    })
    .then((res) => res['data'])
    // eslint-disable-next-line no-console
    .catch((e) =>  console.log('error', e));
  },

  async mxmPayment(context, email) {
    await BookingFlowService.mxmLookup(email)
    .then((res) => {

      const items = [];
      context.dispatch('setMaximail', res['data'].token || null)
      
      // eslint-disable-next-line no-undef
      if (res['data'].token && typeof Mxm !== 'undefined' && Mxm.Basket) {

        // create mxm array of items
        
        // eslint-disable-next-line no-unused-vars
        [..._.cloneDeep(this.state.cart.products.airportparking), ..._.cloneDeep(this.state.cart.products.airporthotel), ..._.cloneDeep(this.state.cart.products.airportlounge)].map((item, _) => {
          items.push({
            'product_code': item.product.product_id,
            'quantity': 1,
            'name': item.product.product_name,
            'value': item.product.price,
            'description': '',
            'custom_fields': {
              'product_name': item.product.product_name,
              'full_price': item.product.full_price,
              'sale_price': item.product.price,
              'dateA': item.quote.dateA,
              'dateB': item.quote.dateB,
              'dateA_text': item.quote.dateA,
              'dateB_text': item.quote.dateB,
              'agent': item.quote.agent,
              'quote': item.quote,
              'airport_id': this.state.results.airport.airport_id
            }
          });
        });

        // set mxm default
        // eslint-disable-next-line no-undef
        Mxm.Basket.setDefaults({
          customer_id: process.env.VUE_APP_CUSTOMER_ID,
          recipient: email,
          basket_type_id: process.env.VUE_APP_BASKET_ID,
          total_value: this.state.cart.total,
          token: this.state.customer.maximail,
          stage: 'paymentpage'
        });

        // set mxm items
        // eslint-disable-next-line no-undef
        Mxm.Basket.setItems({
          customer_id: process.env.VUE_APP_CUSTOMER_ID,
          recipient: email,
          basket_type_id: process.env.VUE_APP_BASKET_ID,
          token: res['data'].token,
          items: items,
          stage: 'paymentpage'
        });
      }
    })
  },

  mxmConfirmation() {

    // eslint-disable-next-line no-undef
    if (this.state.customer.maximail && typeof Mxm !== "undefined" && Mxm.hasOwnProperty('Basket')) {
      // set confirmation step
      // eslint-disable-next-line no-undef
      Mxm.Basket.setStage({
        customer_id: process.env.VUE_APP_CUSTOMER_ID,
        recipient: this.state.customer.email,
        basket_type_id: process.env.VUE_APP_BASKET_ID,
        token: this.state.customer.maximail,
        stage: 'complete'
      });
    }
  },

  // updates vehicles array
  updatePassenger({ dispatch }, data) {
    let passengers  = _.cloneDeep(this.state.customer.passengers)
    passengers[data.index] = data['passenger']
    dispatch('setPassengers', passengers);
  }
};

export default {
  namespaced: true,
  actions,
  mutations,
  state
};